import { mergeStyles } from '@fluentui/merge-styles';
import styles from './LoginPage.module.scss';
import { Button, mergeClasses } from '@fluentui/react-components';
import { Col, Container, Row } from 'react-grid-system';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';

export default function LoginPage() {
    const { t } = useTranslation();
    const { instance } = useMsal();

    const backgroundStyle = mergeStyles({
        background: `url(${process.env.PUBLIC_URL}/img/login.webp)`,
    });

    const loginPageStyle = mergeClasses(styles.loginPage, backgroundStyle);

    return (
        <div className={loginPageStyle}>
            <Container className={styles.container}>
                <Row>
                    <Col>
                        <h1>{t("app.name")}</h1>
                        <h3>{t("app.developer")}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button onClick={() => instance.loginPopup()}>{t("login")}</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}